export default __webpack_public_path__ + "static/media/ChatIcon.2204ff72.svg";